import React from 'react';
import {
  Col,
  Row,
} from 'antd';
import { DocumentAlertPreviewProps } from './types';

const DocumentPreviewIframe = ({
  resourceUrl,
  width,
  height,
  title,
}: DocumentAlertPreviewProps) => {
  const isExcel = /\.(xlsx|xls)(\?|$)/i.test(resourceUrl);
  const previewUrl = isExcel
    ? `https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(resourceUrl)}`
    : resourceUrl;

  return (
    <Row gutter={[16, 16]}>
      <Col xs={24} sm={24} md={24} lg={24} xl={24}>
        <iframe
          id="iframe1"
          loading="lazy"
          width={width}
          height={height}
          src={previewUrl}
          title={title}
          allowFullScreen
        />
      </Col>
    </Row>
  );
};

export default DocumentPreviewIframe;
